import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  forwardRef,
} from '@angular/core';
import { SelectItem } from 'primeng/api';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { finalize } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { UserSelectorService } from '../../services/user-selector.service';

@Component({
  selector: 'user-with-ids-selector',
  templateUrl: './user-with-ids-selector.component.html',
  styleUrls: ['./user-with-ids-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => UserWithIdsSelectorComponent),
      multi: true,
    },
  ],
  standalone: false,
})
export class UserWithIdsSelectorComponent {
  private onChange: (value: any) => void;
  private onTouched: () => void;

  value?: SelectItem;
  disabled = false;
  suggestions: SelectItem[] = [];

  constructor(
    private userSelectorService: UserSelectorService,
    private ref: ChangeDetectorRef,
    private destroyRef: DestroyRef
  ) {}

  loadUsers(event: any): void {
    this.userSelectorService
      .getUsersIncludeUserId(event.query)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        finalize(() => this.ref.markForCheck())
      )
      .subscribe((items) => (this.suggestions = items));
  }

  registerOnChange(fn: (value: any) => any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onClear() {
    this.value = null;
    this.onChange(null);
  }

  selectUser(item: SelectItem): void {
    this.value = item;
    this.onChange(item);
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  writeValue(value: string): void {
    if (value === null) return;
    this.value = { value, label: value };
  }
}
